import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../codegen/Localize';

export function filePathDisplayStringWithBaseNameFirst(filePath: string): string {
  if (filePath) {
    let lastSeparatorIndex = filePath.lastIndexOf('/');
    if (lastSeparatorIndex < 0) {
      lastSeparatorIndex = filePath.lastIndexOf('\\');
    }
    if (lastSeparatorIndex >= 0) {
      const fileBaseName = filePath.slice(lastSeparatorIndex + 1);
      const fileDirectory = filePath.slice(0, lastSeparatorIndex);
      if (fileDirectory.length > 0) {
        const parenthesizedFileDirectory = Messages.parenthesizedArgument({ ITEM: fileDirectory });
        return `${fileBaseName} ${parenthesizedFileDirectory}`;
      } else {
        return filePath;
      }
    }
  }
  return filePath;
}

export function filePathDisplayStringWithoutBaseName(filePath: string): string {
  if (filePath) {
    let lastSeparatorIndex = filePath.lastIndexOf('/');
    if (lastSeparatorIndex < 0) {
      lastSeparatorIndex = filePath.lastIndexOf('\\');
    }
    if (lastSeparatorIndex >= 0) {
      const fileBaseName = filePath.slice(lastSeparatorIndex + 1);
      const fileDirectory = filePath.slice(0, lastSeparatorIndex);
      if (fileDirectory.length > 0) {
        return `${fileDirectory}`;
      } else {
        return filePath;
      }
    }
  }
  return filePath;
}

export function filePathDisplayOnlyFileName(filePath: string): string {
  if (filePath) {
    let lastSeparatorIndex = filePath.lastIndexOf('/');
    if (lastSeparatorIndex < 0) {
      lastSeparatorIndex = filePath.lastIndexOf('\\');
    }
    if (lastSeparatorIndex >= 0) {
      return filePath.slice(lastSeparatorIndex + 1);
    }
  }
  return filePath;
}

export function filePathDisplayForFileConnections(filePath: string, connectionType: string): string {
  if (filePath) {
    const shouldNotDisplayFilePath = FeatureFlags.publishReducedDatasourceEnabled && connectionType === 'hyper' && !filePath.startsWith('Data/Extracts/');
    if (shouldNotDisplayFilePath) {
      return 'Extract.hyper';
    } else {
      return filePathDisplayStringWithBaseNameFirst(filePath);
    }
  }
  return filePath;
}
